import React from 'react';
import Layout from '../components/Layout/Layout';

const MissionOfLibraryPage = () => {
  return (
    <Layout>
      <div id="mission-of-library" className="page-container" style={{ maxWidth: '900px', fontSize: '0.90rem', margin: '40px auto', padding: '0 20px', minHeight: '300px' }}>
        
        <div style={{ backgroundColor: '#fff', padding: '40px 50px', borderRadius: '8px', border: '1px solid #eaeaea', boxShadow: '0 4px 20px rgba(0,0,0,0.04)' }}>
          <h2 style={{ color: '#0056b3', borderBottom: '2px solid #0056b3', paddingBottom: '10px', marginBottom: '40px', fontSize: '2.2rem', fontWeight: 'bold' }}>
            Library Vision & Mission
          </h2>

          {/* Vision Section */}
          <div style={{ marginBottom: '40px' }}>
            <h3 style={{ color: '#0056b3', fontSize: '1.4rem', fontWeight: 'bold', borderLeft: '4px solid #0056b3', paddingLeft: '15px', marginBottom: '15px' }}>
              Vision of The Library
            </h3>
            <div style={{ backgroundColor: '#f4f9fc', padding: '25px', borderRadius: '6px', textAlign: 'center', fontStyle: 'italic', color: '#444', fontSize: '1.1rem', borderLeft: '4px solid #0056b3' }}>
              "To work as a knowledge Resource Centre for the generations to make wisdom full knowledge society"
            </div>
          </div>

          {/* Mission Section */}
          <div style={{ marginBottom: '40px' }}>
            <h3 style={{ color: '#0056b3', fontSize: '1.4rem', fontWeight: 'bold', borderLeft: '4px solid #0056b3', paddingLeft: '15px', marginBottom: '15px' }}>
              MISSION OF THE LIBRARY
            </h3>
            <ol style={{ paddingLeft: '35px', margin: 0, lineHeight: '2', color: '#444', fontSize: '1.05rem' }}>
              <li style={{ marginBottom: '10px' }}>To inculcate reading habits in the young generations and strengthen the reading culture.</li>
              <li style={{ marginBottom: '10px' }}>To promote information literacy to bridge the digital divide.</li>
              <li style={{ marginBottom: '10px' }}>To strengthen the Library resources (Print and electronic) to work efficiently as knowledge resource centos.</li>
            </ol>
          </div>

          {/* Special Features Section */}
          <div>
            <h3 style={{ color: '#0056b3', fontSize: '1.4rem', fontWeight: 'bold', borderLeft: '4px solid #0056b3', paddingLeft: '15px', marginBottom: '15px' }}>
              SPECIAL FEATURES
            </h3>
            <ul style={{ listStyleType: 'disc', paddingLeft: '35px', margin: 0, lineHeight: '2', color: '#444', fontSize: '1.05rem' }}>
              <li style={{ marginBottom: '8px' }}>Fully Automated library with SLIM.</li>
              <li style={{ marginBottom: '8px' }}>Open Access to students</li>
              <li style={{ marginBottom: '8px' }}>Reading Rooms for students & staff</li>
              <li style={{ marginBottom: '8px' }}>Reprographic service</li>
              <li style={{ marginBottom: '8px' }}>Reference Services</li>
              <li style={{ marginBottom: '8px' }}>Newspaper Clipping Services.</li>
              <li style={{ marginBottom: '8px' }}>Facility to access to remote sources.</li>
              <li style={{ marginBottom: '8px' }}>All Books are bar-coded.</li>
            </ul>
          </div>
          
        </div>

      </div>
    </Layout>
  );
};

export default MissionOfLibraryPage;
